import { css } from "@emotion/react";
import styled from "@emotion/styled";
import type { TransitionStatus } from "react-transition-group";
import { ENTERED, EXITED } from "react-transition-group/Transition";

import { ZIndexLayer } from "~/lib/styles/z-index";

export const Layer = styled.div`
  position: fixed;
  inset: 0;
  z-index: -1;

  background-color: #000000;

  opacity: 0;

  transition: opacity 0.2s ease-in-out;
`;

export const MenuWrapper = styled.div`
  inline-size: 100%;
  block-size: 100%;

  background-color: rgb(34, 40, 52);

  overflow: visible auto;

  transition: transform 0.2s ease-in-out;
  overscroll-behavior: none;

  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 375px;
  }
`;

export const MenuBody = styled.div`
  padding-block-end: 120px;
  padding-inline: 24px;
`;

export type ContainerProps = {
  $anchor?: "left" | "right";
  $backdrop?: boolean;
  $state: TransitionStatus;
};

export const Container = styled.div<ContainerProps>`
  position: fixed;
  inset: 0;
  z-index: ${ZIndexLayer.HamburgerMenu};

  display: flex;
  flex-flow: column;
  justify-content: center;

  ${props =>
    props.$anchor === "left"
      ? css`
          align-items: flex-start;
        `
      : css`
          align-items: flex-end;
        `}

  ${props =>
    props.$state === EXITED &&
    css`
      display: none;
    `}

  ${props =>
    props.$state === ENTERED &&
    props.$backdrop &&
    css`
      ${Layer} {
        opacity: 0.5;
      }
      ${MenuWrapper} {
        box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.3);
      }
    `}

  /*
    Avoid transform when it finished animating to avoid tooltip being clipped with the following reason.
    Element with transform other than none, will create containing block. Ref: https://www.w3.org/TR/css-transforms-1/#containing-block-for-all-descendants
    Absolute position element will attach to the nearest containing block.
    And will be clipped if the element is outside the view box of the containing block and the overflow value of the container block is not equals to visible.
  */
  ${props =>
    props.$state !== ENTERED &&
    css`
      ${MenuWrapper} {
        ${props.$anchor === "left"
          ? css`
              transform: translateX(-100%);
            `
          : css`
              transform: translateX(100%);
            `}
      }
    `}
`;
